import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector, clearFields } from "redux-form";
import { Row, Col, ButtonToolbar, Button, Spinner, Alert } from "reactstrap";
import { MdRefresh } from "react-icons/md";
import { validateSearchForm } from "./validateSearchByProgramForm";
import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permissions.constants";
import IssuersDropDown from "../../../Issuers/IssuersDropDown";
import renderSelectField from "../../../../shared/components/form/Select";
import { getCardPrograms, resetCardPrograms } from "../../../Issuers/actions/issuer.actions";
import renderDatePickerField from "../../../../shared/components/form/DatePicker";
let CardStatementSearchByProgramForm = ({ handleSubmit, reset, pristine, invalid, loading, dispatch, resetSearch, selectedIssuer, currentIssuerData, cardPrograms, startDate, endDate, issuerNr }) => {
    const handleGetPostCardPrograms = useCallback(() => {
        if (issuerNr && issuerNr.response && issuerNr.response.data && issuerNr.response.data[0] && issuerNr.response.data[0].issuerCode !== "ISW") {
            dispatch(getCardPrograms(issuerNr.response.data[0].issuerNr));
        }
    }, [dispatch, issuerNr]);

    useEffect(() => {
        handleGetPostCardPrograms();
    }, [handleGetPostCardPrograms]);

    const resetForm = () => {
        reset();
        resetSearch();
        resetCardPrograms();
    };
    useEffect(() => {
        if (issuerNr && issuerNr.response && issuerNr.response.data && issuerNr.response.data[0] && issuerNr.response.data[0].issuerCode !== "ISW") {
            dispatch(getCardPrograms(issuerNr.response.data[0].issuerNr));
        }
    }, [dispatch, currentIssuerData, issuerNr]);

    useEffect(() => {
        dispatch(clearFields("card_statement_programm_search", true, true, "cardProgram"));
        if (!selectedIssuer) {
            dispatch(resetCardPrograms());
        } else {
            dispatch(getCardPrograms(selectedIssuer && selectedIssuer.issuerNr));
        }
    }, [dispatch, selectedIssuer]);
    return (
        <form className="form" onSubmit={handleSubmit}>
            <Row>
                <AccessControl allowedPermissions={[permissionsConstants.FETCH_ISSUER_CONFIGS]} renderNoAccess={() => ""}>
                    <Col lg="3">
                        <IssuersDropDown required id="issuer" label="Select Issuer" />
                    </Col>
                </AccessControl>
                {/* <Col lg="3">
                    <IssuersDropDown required id="issuer" label="Select Issuer" />
                </Col> */}
                <Col lg="3">
                    <div className="form__form-group">
                        <span className="form__form-group-label">Card Program</span>
                        <div className="form__form-group-field">
                            <Field id="cardProgram" name="cardProgram" component={renderSelectField} options={(cardPrograms && cardPrograms.response && cardPrograms.response.cardPrograms) || []} valueKey="cardProgram" labelKey="cardProgram" placeholder="Card Program" />
                            {cardPrograms && cardPrograms.error ? (
                                <Alert color="danger">
                                    Could not fetch issuers
                                    {cardPrograms.loading ? <Spinner className="float-right" size="sm" color="danger" /> : <MdRefresh onClick={handleGetPostCardPrograms} className="float-right pointer" size={20} />}
                                </Alert>
                            ) : null}
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col lg="3">
                    <div className="form__form-group">
                        <span className="form__form-group-label required">Start Date</span>
                        <div className="form__form-group-field">
                            <Field id="startDate" name="startDate" dateFormat="dd/MM/yyyy" maxDate={endDate || new Date()} component={renderDatePickerField} placeholder="Start Date" />
                        </div>
                    </div>
                </Col>
                <Col lg="3">
                    <div className="form__form-group">
                        <span className="form__form-group-label required">End Date</span>
                        <div className="form__form-group-field">
                            <Field id="endDate" name="endDate" dateFormat="dd/MM/yyyy" maxDate={new Date()} minDate={startDate} component={renderDatePickerField} placeholder="End Date" />
                        </div>
                    </div>
                </Col>
                <Col lg="3">
                    <ButtonToolbar className="mt-4 form__button-toolbar">
                        <Button color="primary" type="submit" id="btn-submit-cardStatement" disabled={loading || invalid}>
                            {loading ? (
                                <span>
                                    <Spinner size="sm" color="default" />{" "}
                                </span>
                            ) : null}
                            Search
                        </Button>
                        <Button type="button" id="btn-reset-cardStatement" onClick={resetForm} disabled={pristine || loading}>
                        Reset
                        </Button>
                    </ButtonToolbar>
                </Col>
            </Row>
        </form>
    );
};

CardStatementSearchByProgramForm = reduxForm({
    form: "card_statement_programm_search",
    enableReinitialize: true,
    validate: validateSearchForm,
})(CardStatementSearchByProgramForm);

const selector = formValueSelector("card_statement_programm_search");
CardStatementSearchByProgramForm = connect((state) => {
    return {
        selectedIssuer: selector(state, "issuerNumber"),
        cardPrograms: state.getCardProgramsFromIssuer,
        currentIssuerData: state.cardProgramCount && state.cardProgramCount.request,
        issuerNr: state.getIssuerDomainMapping,
    };
})(CardStatementSearchByProgramForm);

export default CardStatementSearchByProgramForm;
